
import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { WAFModalModel } from '@/store/modules/Index';

@Component({ components: {} })
export default class WAFModal extends Vue {
    @Action('setWAFModal') setWAFModal;

    @Getter getWAFModalSetting!: WAFModalModel;

    closeWAFModalModal() {
        this.setWAFModal({
            ...this.getWAFModalSetting,
            visible: false,
        });
    }
}
